import { createContext, useContext } from 'react';

import type { ApiClient } from './client';

/**
 * The API client is provided rather than imported as a singleton, so tests can hand components a
 * client backed by a stub `fetch` without touching module state.
 */
export const ApiClientContext = createContext<ApiClient | null>(null);

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error('useApiClient must be used inside an <ApiClientProvider>');
  }
  return client;
}
